var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _vm._t("toolbar"),
      _c(
        "el-form",
        [
          _c(
            "vxe-table",
            { ref: "fineTable", attrs: { data: _vm.paymentList } },
            [
              _c("vxe-table-column", {
                attrs: { "min-width": "100", field: "id", title: "明细编码" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "poolAccountCode",
                  title: "红包池编码",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "poolAccountName",
                  title: "红包池名称",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "sourceTypeName",
                  title: "关联客户名称",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "sourceType",
                  title: "客户编码",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "130",
                  field: "amount",
                  title: "红包提现金额（元）",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "120",
                  field: "basicChargeAmount",
                  title: "基础服务费（元）",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "120",
                  field: "upChargeAmount",
                  title: "上浮服务费（元）",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "140",
                  field: "poolDeductionAmount",
                  title: "红包池扣减金额（元）",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "130",
                  field: "createTime",
                  title: "创建时间",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total,prev, pager, next",
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.pageSize,
              total: _vm.pagination.total,
            },
            on: { "current-change": _vm.handleCurrentChange },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }